// @flow strict

import React, { type Node, Fragment } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * Facebook icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const FacebookIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <Fragment>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H35V35H0z" />
        <path
          className="facebook"
          fill={color}
          d="M18.795 26.809H14.93v-9.406H13v-3.24h1.93v-1.946C14.93 9.573 16.02 8 19.119 8h2.579v3.242h-1.612c-1.206 0-1.285.453-1.285 1.298l-.006 1.622h2.92l-.341 3.241h-2.579v9.406z"
        />
      </g>
    </Fragment>
  );
};
